var map = {
	"./assets-hhl/img/index/LOGO 2_1@2x.png": "bc46",
	"./assets-mc/img/index/LOGO 2_1@2x.png": "34a0",
	"./img/index/LOGO 2_1@2x.png": "8dcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b064";